import { Component, HostListener, Inject, OnInit, Optional, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ExcelExportProperties, GridColumnModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../../shared/services/common.service';
import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { getExcelDataSource, gridActionsForFiltering, updateFilterIcon } from '../../../shared/models/utils/grid-functions';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { environment } from '../../../../environments/environment';
import { OpportunitiesPopupComponent } from '../opportunities-popup/opportunities-popup.component';
import { OpportunitiesService } from '../opportunities.service';
import { LeadsPopupComponent } from '../../leads/leads-popup/leads-popup.component';
import { defaultProspectData } from '../../business-partners/model/prospects-data';
import { Applications, ModuleNames, tabsModel } from '../../../shared/models/app.model';
import { SharedService } from 'projects/shared/src/public-api';
import { getCurrentDate } from '../../../shared/models/utils/date-functions';
import { ProspectsPopupComponent } from '../../business-partners/prospects-popup/prospects-popup.component';
import { GridPersistRequests, UserRoles } from '../../../shared/constants/app.constants';
import { HomeService } from '../../home/home.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-opportunities-grid',
    templateUrl: './opportunities-grid.component.html',
    styleUrl: './opportunities-grid.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpportunitiesGridComponent implements OnInit{

  dataSource: any;
  columns!: GridColumnModel[]
  grid!: GridComponent;
  searchSettings?: SearchSettingsModel;
  showLoader = true;
  gridHeight: number = window.innerHeight - 250;
  obsoleteItemsExists: boolean = false
  private subscription?: Subscription;
  rolePermissions: any = {};
  tab: string = 'details';
  gridName: string = 'opportunity-grid';
  showGrid = false
  
  sortOptions = {
    columns: [
      { field: 'createdDate', direction: 'Descending' }
    ]
  };

  prospectData = defaultProspectData;
  showProspectsPopup = false

  @ViewChild('columnChooser') columnChooser: any;
  @ViewChild('addLeads') addLeads: any;
  @ViewChild('obsoleteItemToolbar') obsoleteItemToolbar: any;
  query: Query;

  @ViewChild('opportunityGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.grid = gridComponent;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.gridHeight = window.innerHeight - 250;
  }

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private authService: AuthService,
    private sharedService: SharedService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<OpportunitiesGridComponent>
  ) {
    this.getRolePermission()
    this.getColumns()
  }

  ngOnInit(): void {
    this.loadPage();
    this.query = new Query();
    if(this.dialogData?.isOpenedFromDashboard) {
      const USER = this.commonService.getUSER();
      if(USER?.role == UserRoles.salesRep) {
        this.query.addParams('saleRepId', USER?.userId);
      }
      if(this.dialogData?.filteredStatus && this.dialogData?.filteredStatus != "All") {
        this.query?.where('statusText', 'equal', this.dialogData?.filteredStatus);
      }
      this.dialogData?.districts && (this.query.addParams('district', this.dialogData?.districts));
      this.dialogData?.regions && (this.query.addParams('region', this.dialogData?.regions));
    }
    this.dataSource = new DataManager({

      url: `${environment.saleApiUrl}odata/Opportunity`,
      adaptor: new ODataV4Adaptor(),
      headers: [{'Authorization': `Bearer ${this.authService.getToken()}`}]
    });
    this.showLoader = false
    this.searchSettings = {
      fields:[
    "opportunityId",
    "salesLeadId",
    "saleRep",
    "businessPartner",
    "customerTypeText",
    "productCategoryText",
    "zipCode",
    "territory",
    "district",
    "region"
]
    };
    setTimeout(() => {
    this.loadPage();
  }, 50);
  }

  openLeadsPopup(id: string = null, tab: string = tabsModel.details) {
    const dialog = this.dialog.open(LeadsPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      autoFocus: false,
      data: {
        id: id,
        isMaximized: true,
        tab
      }
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
      this.grid.refresh();
      this.homeService.hitRefreshPods({
          // notif_pod: true,

          LeadStats_pod: true, 
          OppStats_pod: true, 
          PropStats_pod: true, 
          SOStats_pod: true,

          // PV_pod: true,
          // COL_pod: true,

          // SOUPCA_pod: true,
          // SOWUCSAP_pod: true,
          // SORTBP_pod: true,
          // SOAA_pod: true,

          // NL_pod: true,
          // UL_pod: true,
        });
      }
    });
  }


  onBPIdClick(soldToBP) {
    this.prospectData.soldToExtId = soldToBP;
    const dialogRef = this.dialog.open(ProspectsPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      data: {
        showProspectsPopup: true,
        prospectData:this.prospectData,
        id: this.prospectData.soldToExtId,
        tab: tabsModel.details,
        isMaximized: true,
        // isReadOnly: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  // onBPIdClick(soldToBP) {
  //   this.prospectData.soldToExtId = soldToBP
  //   this.showProspectsPopup = true
  // }

  getColumns() {
    const commands = [];
    if(this.dialogData?.filteredStatus) {
      commands.push({ title: 'Details', buttonOption: { iconCss: 'fas fa-tasks', cssClass: 'e-flat details-item' } });
      commands.push({ title: 'Links', buttonOption: { iconCss: 'fas fa-link', cssClass: 'e-flat linked-items' } });
      commands.push({ title: 'Comments', buttonOption: { iconCss: 'fas fa-comment', cssClass: 'e-flat comments-items' } });
      commands.push({ title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } })

      this.columns = [
        { field: "opportunityId", headerText: "Opportunity ID", allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 140, isPrimaryKey: true, showInColumnChooser: false },
        { field: 'salesLeadId', headerText: 'Lead ID', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'leadSource', headerText: 'Lead Source', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'businessPartner', headerText: 'Customer', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'assignedResourceName', headerText: 'Assigned Resource', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
        { field: 'saleRep', headerText: 'Primary Sales Rep', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'customerTypeText', headerText: 'Customer Type', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'salesTypeText', headerText: 'Sale Type', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'productCategoryText', headerText: 'Product', filter: { type: 'Excel' },  type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'zipCode', headerText: 'Zip Code', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'territory', headerText: 'Territory', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'district', headerText: 'District', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'region', headerText: 'Region', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'createdDate', headerText: 'Created Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 180, showInColumnChooser: true },
        { field: 'lastQuotedAmount', headerText: 'Last Quoted', filter: { type: 'Excel' }, type: 'number', format: 'n2', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'expectedCloseDate', headerText: 'Expected Close Date', type: 'date', format: { type: 'date', format: 'd MMM, yyyy' }, allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: "country", headerText: "Country", filter: { type: 'Excel' }, type: 'string', allowEditing: false, width: 140, textAlign: 'Left', showInColumnChooser: true, visible: false },
        {
          field: 'Actions', headerText: 'Actions', width: 200, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
          commands: commands
        }
      ];
      if(this.dialogData?.filteredStatus == "All") {
      const saleRepIndex = this.columns.findIndex(c => c.field === 'saleRep');
      this.columns.splice(saleRepIndex + 1, 0, { field: 'statusText', headerText: 'Status', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 200, visible: true, showInColumnChooser: true });
    }
    } else {
      if (this.rolePermissions['opportunityGrid_details']?.visible ?? true) {
        commands.push({ title: 'Details', buttonOption: { iconCss: 'fas fa-tasks', cssClass: 'e-flat details-item' } });
      }
      if (this.rolePermissions['opportunityGrid_proposal']?.visible ?? true) {
        commands.push({ title: 'Proposal', buttonOption: { iconCss: 'fas fa-file', cssClass: 'e-flat proposal-item' } });
      }
      // if (this.rolePermissions['opportunityGrid_roi']?.visible ?? true) {
      //   commands.push({ title: 'ROI', buttonOption: { iconCss: 'fas fa-hand-holding-dollar', cssClass: 'e-flat roi-item' } });
      // }
      if (this.rolePermissions['opportunityGrid_links']?.visible ?? true) {
        commands.push({ title: 'Links', buttonOption: { iconCss: 'fas fa-link', cssClass: 'e-flat linked-items' } });
      }
      if (this.rolePermissions['opportunityGrid_comments']?.visible ?? true) {
        commands.push({ title: 'Comments', buttonOption: { iconCss: 'fas fa-comment', cssClass: 'e-flat comments-items' } });
      }
      if (this.rolePermissions['opportunityGrid_attachments']?.visible ?? true) {
        commands.push({ title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } });
      }
      if (this.rolePermissions['opportunityGrid_history']?.visible ?? true) {
        commands.push({ title: 'History', buttonOption: { iconCss: 'fas fa-history', cssClass: 'e-flat history-item' } });
      }

      this.columns = [
        { field: "opportunityId", headerText: "Opportunity ID", allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 140, isPrimaryKey: true, showInColumnChooser: false },
        { field: 'salesTypeText', headerText: 'Sale Type', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'businessPartner', headerText: 'Business Partner', type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'assignedResourceName', headerText: 'Assigned Resource', type: 'string', filter: { type: 'Excel' },  allowEditing: false, textAlign: 'Left', width: 250, visible: true, showInColumnChooser: true },
        { field: 'saleRep', headerText: 'Primary Sales Rep', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'statusText', headerText: 'Status', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 170, visible: true, showInColumnChooser: true },
        { field: 'customerTypeText', headerText: 'Customer Type', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
        { field: 'salesLeadId', headerText: 'Lead ID', type: 'String', allowEditing: false, width: 140, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'leadSource', headerText: 'Lead Source', type: 'String', allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'productCategoryText', headerText: 'Product', type: 'String', filter: { type: 'Excel' }, allowEditing: false, width: 160, textAlign: 'Left', visible: true, showInColumnChooser: true },
        { field: 'lastQuotedAmount', headerText: 'Last Quoted', filter: { type: 'Menu' }, type: 'number', format: 'n2', allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
        { field: 'expectedCloseDate', headerText: 'Expected Close Date', type: 'date', format: { type: 'date', format: 'd MMM, y' }, allowEditing: false, textAlign: 'Left', width: 180, visible: true, showInColumnChooser: true },
        { field: 'createdDate', headerText: 'Created Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 160, showInColumnChooser: true },
        { field: 'zipCode', headerText: 'Zip Code', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: false, showInColumnChooser: false },
        { field: 'territory', headerText: 'Territory', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: false, showInColumnChooser: false },
        { field: 'district', headerText: 'District', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: false, showInColumnChooser: false },
        { field: 'region', headerText: 'Region', filter: { type: 'Excel' }, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: false, showInColumnChooser: false },
        { field: "country", headerText: "Country", filter: { type: 'Excel' }, type: 'string', allowEditing: false, width: 140, textAlign: 'Left', showInColumnChooser: true, visible: false },

        {
          field: 'Actions', headerText: 'Actions', width: 200, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
          commands: commands
        }
      ];
    }
  }

  setToolbar() {
    this.grid.toolbar = [
      { id: 'column-chooser', template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      { id: 'refresh', align: 'Right', prefixIcon: 'fas fa-redo-alt', cssClass: '', tooltipText: 'Refresh' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: `grid-filter-icon`, tooltipText: 'Clear all Filters' }
    ];
    
    if (this.commonService.getUSER()?.role !== UserRoles.salesRep) {
      const indexExcelExport = this.grid.toolbar.findIndex(fi => fi == 'Search');
      this.grid.toolbar.splice(indexExcelExport + 1, 0, { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', cssClass: `grid-add-button`, tooltipText: 'Excel Export' })
    }
    const index = this.grid.toolbar.findIndex((item: any) => item.id === 'column-chooser');
    if (index !== -1 && ((this.rolePermissions['opportunityGrid_add']?.visible) || this.commonService?.getUSER()?.canActAsSalesRep ) && !this.dialogData?.isOpenedFromDashboard) {
      this.grid.toolbar.splice(index + 1, 0, { id: 'add', align: 'Left', prefixIcon: 'fas fa-add', cssClass: '', tooltipText: 'Add' });
    }
  }

  updatePersistence(userId: string = '', value: any = '', appName: Applications.RimsSales | Applications.RimsService | '' = Applications.RimsSales) {
    this.commonService.savePersistence({ userId, name: this.gridName, value, appId: appName })
      .subscribe((res: any) => {
        localStorage.setItem(`grid${this.gridName}`, value ?? this.grid?.getPersistData());
      });
  }

  loadPage() {
    this.commonService.getPersistence(this.gridName, '', Applications.RimsSales)
      .subscribe({
        next: (res: any) => {
          if (res && res.result && res.result.length && res.result[0].value) {
            localStorage.setItem(`grid${this.gridName}`, res.result[0].value);
          } else {
            localStorage.removeItem(`grid${this.gridName}`);
          }
          this.showGrid = true;
          this.showLoader = false;
        },
        error: (err) => {
          this.showGrid = true;
          this.showLoader = false;
          this.commonService.showNotification("error", err?.error?.message);
        }
      });
  }

  getRolePermission() {
    this.commonService.getRolePermission('opportunity','opportunityGrid','opportunity').subscribe((res: any) => {
      res.result.forEach((rule: any) => {
        this.rolePermissions[rule.ruleAction] = {
            visible: rule.visible,
            readOnly: rule.readOnly,
            enable: rule.enable,
        }
      });
      this.setToolbar()
    }, (error: HttpErrorResponse) => {
      throw error;
    });
  }

  onToolbarClick(args: any ) {
    if (args.item.id === 'add') {
      this.openOpportunityPopup()
    } else if (args.item.id === 'clear-filter') {
      this.grid.clearFiltering();
      this.grid.search('');
      this.updatePersistence();
    } else if (args.item.id === 'excel-export') {
      const dataSource = getExcelDataSource(this.grid);
      let excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: {
          header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
        },
        fileName: `Opportunities (${getCurrentDate()}).xlsx`
      };
      this.grid.excelExport(excelExportProperties);
    } else if (args.item.id === 'refresh') {
      this.grid.refresh()
    }
  }

  openOpportunityPopup(id: string = null, tab: string = 'details') {
    const dialog = this.dialog.open(OpportunitiesPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      autoFocus: false,
      data: {
        id: id,
        isMaximized: true,
        type: 'indirect',
        tab
      }
    });
    dialog.afterClosed().subscribe(result => {
      this.grid.refresh();
      if (result) {
        this.homeService.hitRefreshPods({
          // notif_pod: true,

          LeadStats_pod: true, 
          OppStats_pod: true, 
          PropStats_pod: true, 
          SOStats_pod: true,

          // PV_pod: true,
          // COL_pod: true,

          // SOUPCA_pod: true,
          // SOWUCSAP_pod: true,
          // SORTBP_pod: true,
          // SOAA_pod: true,

          // NL_pod: true,
          // UL_pod: true,
        });
      }
    });
  }

  commandClick(args: any, grid) {
    switch (args.commandColumn.title) {
      case 'Details':
        this.openOpportunityPopup(args.rowData.opportunityId,'details')
        break;
      case 'Convert to Opportunity':
        this.commonService.showConfirmation("Are you sure, you want to convert this lead to opportunity?")
        .then(result => {
          if (result.isConfirmed) {
            // this.showLoader = true
        }})
        break;
      case 'Proposal':
        this.openOpportunityPopup(args.rowData.opportunityId, 'proposals');
        break;
      case 'Links':
        this.openOpportunityPopup(args.rowData.opportunityId, tabsModel.links)
        break;
      case 'Comments':
        this.sharedService.globalComments = {
          grid, module: ModuleNames.Opportunity, moduleId: args.rowData.opportunityId, showComments: true
        }
        break;
      case 'History':
        this.openOpportunityPopup(args.rowData.opportunityId, tabsModel.history)
        break;
      case 'Attachments':
        this.openOpportunityPopup(args.rowData.opportunityId, tabsModel.attachments)
        break;
      default:
        console.log('Unknown command');
    }
  }

  onGridActionComplete(args: any, grid: any) {
    // gridActionsForFiltering(args, grid);
    updateFilterIcon(args, grid)
    if (GridPersistRequests.includes(args.requestType)) {
      this.updatePersistence('', this.grid?.getPersistData());
    }
  }

  created() {
    this.setToolbar();
    this.route.queryParamMap.subscribe(params => {
      const primaryId = params.get('primaryId');
      const showComments = params.get('showComments') === 'true';
      if (primaryId && showComments) {
        this.openOpportunityPopup(primaryId, 'details');
        setTimeout(() => {
          this.sharedService.globalComments = {
            grid: this.grid,
            module: ModuleNames.Opportunity,
            moduleId: primaryId,
            showComments: true
          };
        }, 500);
        return;
      }
      if (primaryId) {
        this.openOpportunityPopup(primaryId, 'details');
      }
    });
  }

  dataBound(args: any) {
    setTimeout(()=> {
        updateFilterIcon({ requestType: 'filtering' }, this.grid);
    },)
  }

  onRowDataBound(args: any) {
    const data = args.data;
    const $row = args.row;

    if (data.attColorCode) {
      const element = $row.getElementsByClassName('attachments-items')[0]
      if (element) {
        element.style.color = data.attColorCode;
      }
    }
    if (data.linkColorCode) {
      const element = $row.getElementsByClassName('linked-items')[0]
      if (element) {
        element.style.color = data.linkColorCode;
      }
    }
    if (data.commentColor) {
      const element = $row.getElementsByClassName('comments-items')[0]
      if (element) {
        element.style.color = data.commentColor;
      }
    }
    if (data.mappedColorCode) {
      const element = $row.getElementsByClassName('map-business-partner-item')[0]
      if (element) {
        element.style.color = data.mappedColorCode;
      }
    }
    if (data.salesProcessColorCode) {
      const element = $row.getElementsByClassName('details-item')[0]
      if (element) {
        element.style.color = data.salesProcessColorCode;
      }
    }

    if (data.statusText === 'Qualified') {
      $row?.getElementsByClassName('convert-opportunity-item')[0]?.classList.remove('disabled');
    } else {
      $row?.getElementsByClassName('convert-opportunity-item')[0]?.classList.add('disabled');
    }
  }


  getStatusClass(status: string) {
    return this.commonService.getStatusClass(status);
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
}
